import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import ComparisonTable from './components/ComparisonTable';
import TrustSection from './components/TrustSection';
import FAQ from './components/FAQ';
import GuidePreview from './components/GuidePreview';
import ArticlesGrid from './components/ArticlesGrid';
import CTA from './components/CTA';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.asia';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      name: 'Pandabuy.asia',
      url: siteUrl,
      description: 'The largest Pandabuy Spreadsheet directory for sneakers, clothing, bags and hidden finds. Browse 50,000+ verified shopping links across 14 categories.',
      inLanguage: 'en',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://kaspreadsheet.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Pandabuy.asia',
      url: siteUrl,
      description: 'The largest Pandabuy Spreadsheet directory — community-verified shopping links updated daily.',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Best Pandabuy Spreadsheet 2026 (50,000+ Verified Finds) | Pandabuy.asia',
      description: 'Discover thousands of verified fashion finds, shoes, clothing, accessories and budget picks. The largest Pandabuy Spreadsheet directory.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
      },
      mainEntity: {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is a Pandabuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'A Pandabuy Spreadsheet is a curated collection of verified shopping links, product references, and community-discovered finds organized in an easy-to-browse format. It helps shoppers quickly discover popular fashion items, compare prices, and access reliable product links.',
            },
          },
          {
            '@type': 'Question',
            name: 'How does the Pandabuy Spreadsheet work?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Each spreadsheet category contains organized links to specific products across different platforms. Simply browse the category you are interested in, click through to view the products, and use the links to make your purchases.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is the Pandabuy Spreadsheet free to use?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes, browsing our Pandabuy Spreadsheet directory is completely free. We provide organized access to product categories and shopping links at no cost.',
            },
          },
          {
            '@type': 'Question',
            name: 'How often is the spreadsheet updated?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Our Pandabuy Spreadsheet is updated daily to ensure all links are working, new products are added, and outdated items are removed.',
            },
          },
          {
            '@type': 'Question',
            name: 'Are the product links verified and safe?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'All links in our Pandabuy Spreadsheet go through a verification process. We always recommend users exercise standard online shopping precautions and check seller ratings before making purchases.',
            },
          },
          {
            '@type': 'Question',
            name: 'Which categories are most popular?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Shoes, Hoodies/Sweaters, and T-Shirts consistently rank as our most popular Pandabuy Spreadsheet categories with the largest selection of verified links.',
            },
          },
        ],
      },
    },
  ],
};

export default function Home() {
  return (
    <main>
      <JsonLd data={homeSchema} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <WhatIsSection />
      <ComparisonTable />
      <TrustSection />
      <FAQ />
      <ArticlesGrid />
      <GuidePreview />
      <CTA />
      <Footer />
    </main>
  );
}